import React from "react";
import "./RollerLoadingAnimation.css";

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export default function RollerLoadingAnimation({
  className = "",
  style = {},
}: Props) {
  return (
    <div className={className + " roller-animation"} style={style}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
